import * as React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Button } from 'relevant-ui'
import { withTranslation } from 'react-i18next'
import {
  Field,
  reduxForm,
  getFormValues,
} from 'redux-form'
import { FIELDS, Props } from '../types'
import InputField from '@App/components/fields/InputField'
import { SUBMIT } from '@App/constantes'

class Informations extends React.Component<any, any> {
  constructor(props: Props) {
    super(props)

    this.state = {}

    this.onSubmit = this.onSubmit.bind(this)
  }

  onSubmit() {
    this.props.onSubmit(this.props[FIELDS.PHONE])
  }

  render() {
    const {
      invalid,
      t,
      handleSubmit,
      pristine,
    } = this.props

    return (
      <div className="customform customform--padding">
        <p className="customform__title customform__title--center">Etape 1</p>

        <p className="customform__desc" style={{ textAlign: 'center' }}>
          Add an extra layer of security with Two-Step verification
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Vel saepe quod modi labore
        </p>

        <form
          onSubmit={handleSubmit(this.onSubmit)}
          className="customForm mt-20"
          style={{ marginLeft: 'auto', marginRight: 'auto', maxWidth: '500px' }}
        >
          <div className="customform__row">
            <div className="formGroup formGroup--large">
              <Field
                name={FIELDS.PHONE}
                component={InputField}
                label={t('phone')}
                type="tel"
                secondary
              />
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              button="primary"
              size="large"
              type="submit"
              disabled={pristine || invalid}
              label={SUBMIT}
            />
          </div>
        </form>
      </div>
    )
  }
}

const validate = (values: any) => {
  const regex = /^(?:(?:\+|00)33[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/
  const error = {}

  if (!values[FIELDS.PHONE]) {
    error[FIELDS.PHONE] = 'Field cannot be empty'
  }

  if (values[FIELDS.PHONE] && !regex.test(values[FIELDS.PHONE])) {
    error[FIELDS.PHONE] = 'The field must be a valid phone format'
  }

  return error
}

const NewInformationsForm = reduxForm({
  validate,
  form: FIELDS.FORM,
})(Informations as any)

const mapStateToProps = (state: any): any => {
  const values = getFormValues(FIELDS.FORM)(state) || {}
  return {
    ...values,
  }
}

export default compose(
  withTranslation(),
  connect(mapStateToProps),
)(NewInformationsForm)
